import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Style.
 */

const StyledDescriptionDiv = styled.div`
  line-height: 24px;
  color: ${(p) => p.theme.greys.shade80};
  font-weight: ${fontWeights.normal};
`;

/*
 * Component.
 */

export const InfoBubbleDescription: FC<PropsWithChildren<unknown>> = (props) => (
  <StyledDescriptionDiv>{props.children}</StyledDescriptionDiv>
);
